<template>
  <section class="shortstay-section">
    <div class="triplea-container">
      <div class="row">
        <div class="col-xl-6">
          <div class="shortstay-bigcard">
            <div class="shortstay-bigcard-image-wrapper">
              <img src="@/assets/img/triplea/home/short-stay/shortstay-big-image.png" />
            </div>
            <div class="shortstay-bigcard-content-wrapper">
              <h3>Transforme seu imóvel Triple A em uma oportunidade valiosa</h3>
              <p>Possui um imóvel de alto padrão pronto para ganhar destaque? Conecte-se com quem valoriza o luxo e o exclusivo. Nossa equipe de especialistas garante visibilidade e alcance para o seu empreendimento, seja ele residencial ou comercial. Deixe seu imóvel nas mãos de quem entende o verdadeiro valor de uma experiência AAA no mercado.</p>
              <button @click="$bvModal.show('AdvertiseModal')" class="action-custom-button">
                Anunciar  imóvel
                <span>
                  <img src="@/assets/img/triplea/home/top-right-arrow.svg">
                </span>
              </button>
            </div>
          </div>
        </div>
        <div class="col-xl-6">
          <div class="shortstay-smallcards-wrapper">
            <div class="shortstay-smallcard brown-bg">
              <div class="shortstay-smallcard-content-wrapper">
                <h3>Invista no futuro com imóveis de alto padrão</h3>
                <p>Imóveis com retorno financeiro imediato. Seu dinheiro parado no banco pode gerar muito mais retorno quando investido no lugar certo.</p>
                <a href="/triplea/busca" class="action-custom-button dark">
                  Ver imóveis para investir
                  <span>
                    <img src="@/assets/img/triplea/home/top-right-arrow-light.svg">
                  </span>
                </a>
              </div>
              <div class="shortstay-smallcard-image-wrapper">
                <img src="@/assets/img/triplea/home/short-stay/shortstay-small-image-1.png" />
              </div>
            </div>
            <div class="shortstay-smallcard light-bg">
              <div class="shortstay-smallcard-content-wrapper">
                <h3>Imóveis novos e exclusivos de alto padrão</h3>
                <p>Mude para o extraordinário com imóveis que redefinem o conceito de luxo.</p>
                <a href="/lancamentos" class="action-custom-button">
                  Ver lançamentos
                  <span>
                    <img src="@/assets/img/triplea/home/top-right-arrow.svg">
                  </span>
                </a>
              </div>
              <div class="shortstay-smallcard-image-wrapper">
                <img src="@/assets/img/triplea/home/short-stay/shortstay-small-image-2.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
import "@/assets/scss/custom/triplea/components/_short_stay_section.scss";

export default {
  components: {
  },
  data() {
    return {
    };
  },
};
</script>

